// 首页section2
// var viewMoneTab2 = document.querySelector('.collection-tabs-view-more-link2')

// var link2 = viewMoneTab2.querySelectorAll('.collection-tabs__list-link2')
// var button2 = viewMoneTab2.querySelectorAll('.tabs-loading-more-button2')

// viewMoneTab2.addEventListener('click',()=>{
//     console.log('ljdslkfjsdalkfjsdklofjsdaklf');
// })

// button2.forEach((b,i) => {
//     if (i > 0) {
//         b.classList.add('dis_none')
//     }

// })

// link2.forEach((l ,i) => {
//     l.addEventListener('click', () => {
//         console.log('打印哒哒哒哒哒哒2' + i);
//         button2.forEach((b,index) => {
//             if (index === i) {
//                 b.classList.remove('dis_none');
//             } else {
//                 b.classList.add('dis_none');
//             }
        
//         })
//     })
// })

var viewMoneTab2 = document.querySelector('.cccl2')
// viewMoneTab2.addEventListener('click',()=>{
//          console.log('ljdslkfjsdalkfjsdklofjsdaklf');
//     })

var linkk2 = viewMoneTab2.querySelectorAll('.collection-tabs__list-link2')
var buttonn2 = viewMoneTab2.querySelectorAll('.tabs-loading-more-button2')


// viewMoneTab2.addEventListener('click',()=>{
//     console.log('ljdslkfjsdalkfjsdklofjsdaklf');
// })

buttonn2.forEach((b,i) => {
    if (i > 0) {
        b.classList.add('dis_none')
    }

})

linkk2.forEach((l ,i) => {
    l.addEventListener('click', () => {
        // console.log('打印哒哒哒哒哒哒2' + i);
        buttonn2.forEach((b,index) => {
            if (index === i) {
                b.classList.remove('dis_none');
            } else {
                b.classList.add('dis_none');
            }
        
        })
    })
})